export default "__VITE_ASSET__kq3Nc6eB__"